/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Storage_Cloud_LabelInputs */

const en_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud Storage`)
};

const fr_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage cloud`)
};

const de_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud-Speicher`)
};

const it_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviazione cloud`)
};

const ru_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Облачное хранилище`)
};

const es_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento en la nube`)
};

const zh_cn2_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`云存储`)
};

const ja_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラウドストレージ`)
};

const hi_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घन संग्रहण`)
};

const pt_pt2_iframe_remote_storage_cloud_label = /** @type {(inputs: Iframe_Remote_Storage_Cloud_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento em nuvem`)
};

/**
* | output |
* | --- |
* | "Cloud Storage" |
*
* @param {Iframe_Remote_Storage_Cloud_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_storage_cloud_label = /** @type {((inputs?: Iframe_Remote_Storage_Cloud_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Storage_Cloud_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_storage_cloud_label(inputs)
	if (locale === "de") return de_iframe_remote_storage_cloud_label(inputs)
	if (locale === "it") return it_iframe_remote_storage_cloud_label(inputs)
	if (locale === "ru") return ru_iframe_remote_storage_cloud_label(inputs)
	if (locale === "es") return es_iframe_remote_storage_cloud_label(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_storage_cloud_label(inputs)
	if (locale === "ja") return ja_iframe_remote_storage_cloud_label(inputs)
	if (locale === "hi") return hi_iframe_remote_storage_cloud_label(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_storage_cloud_label(inputs)
	return en_iframe_remote_storage_cloud_label(inputs)
});